var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarAstrik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8199 0L18.1799 0V11.1706L10.2811 3.2718L4.1717 9.38118L12.0705 17.28H0.899902V25.92H12.0705L4.1717 33.8187L10.2811 39.9282L18.1799 32.0293V43.2H26.8199V32.0293L34.7188 39.9282L40.8282 33.8189L32.9292 25.92H44.0999V17.28H32.9292L40.8282 9.38118L34.7188 3.27177L26.8199 11.1706V0Z",
    fill: "#31742D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarAstrik);
export default __webpack_public_path__ + "static/media/star_astrik.b760396a21cce6217927e0211be8cafa.svg";
export { ForwardRef as ReactComponent };